/**
 * Web Scrobbler — now-playing scrobbler for music sites
 *
 * Declares two WAR groups — `connectors/*` and `icons/*` — both matched to <all_urls>
 * with no `use_dynamic_url`, so every connector script and toolbar icon is fetchable at a
 * fixed URL from any page.
 *
 * The main toolbar icon is the cleanest signal: icons/icon_main_128.png is vendor-named
 * and loads through probeImage with no CORS grant. Connector scripts are named after the
 * sites they support, so a connector path is highly distinctive to Web Scrobbler.
 *
 * Manifest verified against version 3.22.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'hhinaapppaileiechjoiifaancjggfjm';

export const webScrobbler: ExtensionDefinition = {
  id: ID,
  name: 'Web Scrobbler',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'connectors/* and icons/* exposed to every origin with no dynamic URL. The vendor-named ' +
    'main icon is conclusive and CORS-free.',
  signals: [
    {
      id: 'war-icon-main-128',
      kind: 'web-accessible-resource',
      description:
        'Load icons/icon_main_128.png via <img> — the main toolbar icon exposed to every ' +
        'origin, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'icons/icon_main_128.png'),
    },
    {
      id: 'war-connector-1001tracklists',
      kind: 'web-accessible-resource',
      description:
        'Fetch connectors/1001tracklists.js — a site connector script; the connectors/ ' +
        'naming is distinctive to Web Scrobbler.',
      weight: 0.5,
      run: () => probeFetch(ID, 'connectors/1001tracklists.js'),
    },
    {
      id: 'war-action-base-32-dark',
      kind: 'web-accessible-resource',
      description:
        'Load icons/action_base_32_dark.png via <img> — a themed action icon, a third path.',
      weight: 0.5,
      run: () => probeImage(ID, 'icons/action_base_32_dark.png'),
    },
  ],
};
